import { FC } from "react";
import { Box, Button, styled, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const FlexBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center"
}));

const NotFoundRoot = styled(FlexBox)(() => ({
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh"
}));

const JustifyBox = styled(FlexBox)(() => ({
  maxWidth: 600,
  maxHeight: 500,
  flexDirection: "column",
  justifyContent: "center",
  padding: "20px"
}));

const IMG = styled("img")({
  width: "100%",
  marginBottom: "32px"
});

const NotFound: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <NotFoundRoot>
      <JustifyBox>
        <IMG src="/assets/images/illustrations/3671320.jpg" alt="" />
        <Typography variant="h5" sx={{ text: 'center' }}>{t('notFoundPage.details')}</Typography>
        <Button
          color="primary"
          variant="contained"
          sx={{ textTransform: "capitalize", mt: '32px' }}
          onClick={() => navigate(-1)}>
          {t('notFoundPage.goToHomePageButtonText')}
        </Button>
      </JustifyBox>
    </NotFoundRoot>
  );
};

export default NotFound;